import React from "react";
import { Accordion, Form, Row, Col } from "react-bootstrap";
import { getSteps } from "../utils/timeline";

const StepDurationEditor = ({ customDurations, onDurationChange }) => {
  const steps = getSteps();

  const handleDurationChange = (stepName, field, value) => {
    const newDuration = {
      ...customDurations[stepName],
      [field]: parseInt(value) || 0,
    };
    onDurationChange(stepName, newDuration);
  };

  return (
    <Accordion className="mb-4">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Customize Step Durations</Accordion.Header>
        <Accordion.Body>
          <div className="step-durations">
            {steps.map((step) => (
              <Row key={step.name} className="mb-3 align-items-center">
                <Col xs={12} md={4}>
                  <Form.Label className="mb-0">{step.name}</Form.Label>
                </Col>
                <Col xs={6} md={4}>
                  {step.duration.hours !== undefined && (
                    <Form.Group>
                      <Form.Control
                        type="number"
                        min="0"
                        placeholder={`${step.duration.hours} hours`}
                        value={
                          (customDurations[step.name]?.hours !== undefined
                            ? customDurations[step.name].hours
                            : step.duration.hours) || ""
                        }
                        onChange={(e) =>
                          handleDurationChange(
                            step.name,
                            "hours",
                            e.target.value
                          )
                        }
                      />
                      <Form.Text className="text-muted">Hours</Form.Text>
                    </Form.Group>
                  )}
                </Col>
                <Col xs={6} md={4}>
                  {step.duration.minutes !== undefined && (
                    <Form.Group>
                      <Form.Control
                        type="number"
                        min="0"
                        max="59"
                        placeholder={`${step.duration.minutes} minutes`}
                        value={
                          (customDurations[step.name]?.minutes !== undefined
                            ? customDurations[step.name].minutes
                            : step.duration.minutes) || ""
                        }
                        onChange={(e) =>
                          handleDurationChange(
                            step.name,
                            "minutes",
                            e.target.value
                          )
                        }
                      />
                      <Form.Text className="text-muted">Minutes</Form.Text>
                    </Form.Group>
                  )}
                </Col>
              </Row>
            ))}
            <div className="text-muted small">
              Note: Leave fields empty to use default durations. For
              temperature-dependent steps, duration will be automatically
              adjusted based on temperature.
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default StepDurationEditor;
